import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { IClassType, IClassTypeDTO } from '../interfaces/class-types.interface';
import { IEnum, IEnumDTO } from '../interfaces/enum.interface';

@Injectable({
    providedIn: 'root',
})
export class EnumsService {
    constructor(private http: HttpClient) {}

    // TODO check on back-end encapsulation - (roles for most of enums except last ones)

    public getRolesEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.ROLES).pipe(map((result: IEnumDTO) => result.roles));
    }

    public getGendersEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.GENDERS).pipe(map((result: IEnumDTO) => result.roles));
    }

    public getEducationLevelsEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.EDUCATION_LEVELS).pipe(map((result: IEnumDTO) => result.roles));
    }

    public getEducationTypesEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.EDUCATION_TYPES).pipe(map((result: IEnumDTO) => result.roles));
    }

    public getCostsRepartitionEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.COSTS_REPARTITION).pipe(map((result: IEnumDTO) => result.roles));
    }

    public getClassTypesEnum(): Observable<IClassType[]> {
        return this.http
            .get<IClassTypeDTO>(environment.wasoApi + SubUrlsEnum.CLASS_TYPES)
            .pipe(map((result: IClassTypeDTO) => result.roles));
    }

    public getRateTypesEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.RATE_TYPES).pipe(map((result: IEnumDTO) => result.rate_types));
    }

    public getCustodyTypesEnum(): Observable<IEnum[]> {
        return this.http
            .get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.CUSTODY_TYPES)
            .pipe(map((result: IEnumDTO) => result.custody_types));
    }

    public getRelativeTypesEnum(): Observable<IEnum[]> {
        return this.http
            .get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.RELATIVE_TYPES)
            .pipe(map((result: IEnumDTO) => result.relative_types));
    }

    public getContactTypesEnum(): Observable<IEnum[]> {
        return this.http
            .get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.CONTACT_TYPES)
            .pipe(map((result: IEnumDTO) => result.contact_types));
    }

    public getCreditTypesEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.CREDIT_TYPES).pipe(map((result: IEnumDTO) => result.credit_types));
    }

    public getDebitTypesEnum(): Observable<IEnum[]> {
        return this.http.get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.DEBIT_TYPES).pipe(map((result: IEnumDTO) => result.debit_types));
    }

    public getStorageTypesEnum(): Observable<IEnum[]> {
        return this.http
            .get<IEnumDTO>(environment.wasoApi + SubUrlsEnum.STORAGE_TYPES)
            .pipe(map((result: IEnumDTO) => result.storage_types));
    }
}
